import spa from '../images/spa.png';
import spaDark from '../images/spa-dark.png';
import ogSpa from '../images/og-spa.jpg';
import ogSpaDark from '../images/og-spa-dark.jpg';

import problem from '../images/problem.png';
import problemDark from '../images/problem-dark.png';
import ogProblem from '../images/og-problem.jpg';
import ogProblemDark from '../images/og-problem-dark.jpg';

import task from '../images/task.png';
import taskDark from '../images/task-dark.png';
import ogTask from '../images/og-task.jpg';
import ogTaskDark from '../images/og-task-dark.jpg';

import solution from '../images/solution.png';
import solutionDark from '../images/solution-dark.png';
import ogSolution from '../images/og-solution.jpg';
import ogSolutionDark from '../images/og-solution-dark.jpg';

import technologies from '../images/technologies.png';
import technologiesDark from '../images/technologies-dark.png';
import ogTechnologies from '../images/og-technologies.jpg';
import ogTechnologiesDark from '../images/og-technologies-dark.jpg';

import result from '../images/result.png';
import resultDark from '../images/result-dark.png';
import ogResult from '../images/og-result.jpg';
import ogResultDark from '../images/og-result-dark.jpg';

import why from '../images/why.png';
import whyDark from '../images/why-dark.png';
import ogWhy from '../images/og-why.jpg';
import ogWhyDark from '../images/og-why-dark.jpg';

import who from '../images/who.png';
import whoDark from '../images/who-dark.png';
import ogWho from '../images/og-who.jpg';
import ogWhoDark from '../images/og-who-dark.jpg';

import notFound from '../images/not-found.png';
import notFoundDark from '../images/not-found-dark.png';
import ogNotFound from '../images/og-not-found.jpg';
import ogNotFoundDark from '../images/og-not-found-dark.jpg';

export const images = {
    spa: {
        image: spa,
        darkImage: spaDark,
        ogImage: ogSpa,
        darkOgImage: ogSpaDark
    },
    problem: {
        image: problem,
        darkImage: problemDark,
        ogImage: ogProblem,
        darkOgImage: ogProblemDark
    },
    task: {
        image: task,
        darkImage: taskDark,
        ogImage: ogTask,
        darkOgImage: ogTaskDark
    },
    solution: {
        image: solution,
        darkImage: solutionDark,
        ogImage: ogSolution,
        darkOgImage: ogSolutionDark
    },
    technologies: {
        image: technologies,
        darkImage: technologiesDark,
        ogImage: ogTechnologies,
        darkOgImage: ogTechnologiesDark
    },
    result: {
        image: result,
        darkImage: resultDark,
        ogImage: ogResult,
        darkOgImage: ogResultDark
    },
    why: {
        image: why,
        darkImage: whyDark,
        ogImage: ogWhy,
        darkOgImage: ogWhyDark
    },
    who: {
        image: who,
        darkImage: whoDark,
        ogImage: ogWho,
        darkOgImage: ogWhoDark
    },
    notFound: {
        image: notFound,
        darkImage: notFoundDark,
        ogImage: ogNotFound,
        darkOgImage: ogNotFoundDark
    }
}